var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentDefinition)?_c('popover',{attrs:{"position":_vm.currentDefinitionPosition,"data":_vm.currentDefinition,"definition-path-prefix":_vm.definitionPathPrefix,"blob-path":_vm.currentBlobPath}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }